import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Departments from "@/pages/Departments";
import DailyConnect from "@/pages/DailyConnect";
import Goals from "@/pages/Goals";
import DigitalAssets from "@/pages/DigitalAssets";
import Expansion from "@/pages/Expansion";
import PatientExperience from "@/pages/PatientExperience";
import Ecosystem from "@/pages/Ecosystem";
import Reports from "@/pages/Reports";

// Gate CEO-only pages by the real role (not the "view as" preview), so a direct
// URL visit by a non-CEO is redirected instead of rendering admin controls.
function CeoRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "ceo") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/daily-connect" element={<DailyConnect />} />
              <Route path="/okr-engine" element={<Goals />} />
              <Route path="/digital-assets" element={<DigitalAssets />} />
              <Route path="/expansion" element={<Expansion />} />
              <Route path="/patient-experience" element={<PatientExperience />} />
              <Route path="/ecosystem" element={<Ecosystem />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<CeoRoute><Settings /></CeoRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
